/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { Spin, Result, Button } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { resetVerifyEmailState, verifyEmail, verifyEmailSelector } from 'src/features'
import { CustomModal } from 'src/components'
import { removeToken } from 'src/core/helpers/auth'


const WelcomeModal: React.FC = () => {
  const { t } = useTranslation()
  const router = useRouter()
  const dispatch = useAppDispatch()
  const { verificationCode, onBooking } = useRouter().query
  const [isModalVisible, setIsModalVisible] = useState<boolean>(Boolean(onBooking))

  const { success: successVerify, error: errorVerify } = useAppSelector(verifyEmailSelector)

  useEffect(() => {
    removeToken()
    setIsModalVisible(Boolean(onBooking))

    if (verificationCode) {
      const timer = setTimeout(() => {
        dispatch(verifyEmail(String(verificationCode)))
      }, 2000)

      return () => clearTimeout(timer)
    }
  }, [dispatch, verificationCode, onBooking])

  useEffect(() => {
    if (successVerify) {
      resetState('success')
    }
    if (errorVerify) {
      resetState('error')
    }
  }, [successVerify, errorVerify])

  const resetState = (type: 'success' | 'error') => {
    if (type === 'error') {
      dispatch(resetVerifyEmailState())
      router.push(`/auth/login?verifyStatus=${type}`)
    }
  }

  const handleClose = () => {
    dispatch(resetVerifyEmailState())
    setIsModalVisible(false)
  }

  const renderContent = () => {
    if (!successVerify) {
      return (
        <Result
          title={t('Auth.Password.VerifyingEmail')}
          extra={<Spin className='centered-div mt-6' size='large' />}
        />
      )
    }

    return (
      <Result
        status='success'
        title={t('user.WelcomeClimateTrade')}
        subTitle={t('Auth.Password.AccessMessage')}
      />
    )
  }

  return (
    <CustomModal
      width={450}
      footer={<Button onClick={handleClose} type='primary'>{t('card.Continue')}</Button>}
      destroyOnClose
      title={t('Auth.Password.ThankYouRegistering')}
      open={isModalVisible}
    >
      {renderContent()}
    </CustomModal>
  )
}

export default WelcomeModal
